<template>
  <!-- Begin Page Content -->
  <div class="container">
    <div class="row justify-content-between">
      <div class="col">
        <h4 class="h3 mb-2 text-gray-800">Xичээлийн группууд</h4>
      </div>
    </div>
    <!-- Page Heading -->
    <!-- DataTales Example -->
    <div class="card shadow-sm my-4">
      <div class="card-header row m-0">
        <div class="col"></div>
        <div class="col-auto">
          <div
            v-if="
              currentUser != null &&
              userProfile != null &&
              (userProfile.role == 'admin' ||
                userProfile.role == 'sts' ||
                userProfile.role == 'manager')
            "
            @click="
              $router.push({
                name: 'GroupAdd',
                params: { setTeacher: true, schoolId: school.id },
              })
            "
            class="btn btn-danger btn-sm"
            style="cursor: pointer"
          >
            Групп үүсгэx
          </div>
          <div
            v-else
            @click="
              $router.push({
                name: 'GroupAdd',
                params: { schoolId: school.id },
              })
            "
            class="btn btn-danger btn-sm"
            style="cursor: pointer"
          >
            Групп үүсгэx
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            v-if="lessonGroups != null"
          >
            <thead>
              <tr>
                <th style="width: 1%">№</th>
                <th style="width: 20%">Анги</th>
                <th>Группын нэр</th>
                <th v-if="isXAdmin(userProfile)"></th>
                <th style="width: 30%">Xичээлийн нэр</th>
                <th style="width: 10%">Үүсгэсэн огноо</th>
                <th style="width: 20%">Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(lesson, index) in lessonGroups"
                v-bind:key="lesson.id"
              >
                <template v-if="lesson.startYear == 2021 && lesson.startMonth >=9">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <ul
                      class="text-primary"
                      v-if="lesson.groups && lesson.groups.length > 0"
                    >
                      <li
                        style="cursor: pointer"
                        v-for="(group, index) in lesson.groups"
                        :key="index"
                        @click="
                          $router.push({
                            name: 'IGroupStudents',
                            params: {
                              schoolId: school.schoolId,
                              departmentId: group.department.id,
                              programId: group.program.id,
                            },
                          })
                        "
                      >
                        <span v-if="group.departmentName">{{
                          group.departmentName
                        }}</span>
                        <span v-else>-</span>
                        <span v-if="group.programName">{{
                          group.programName
                        }}</span>
                        <span v-else>-</span>
                        <span v-if="index < lesson.groups.length - 1">, </span>
                        <span v-if="isXAdmin(userProfile)">{{ group.id }}</span>
                      </li>
                    </ul>
                  </td>
                  <td>
                    {{ lesson.name }}
                    <span v-if="isXAdmin(userProfile)">{{ lesson.id }} </span>
                    <!-- <br/>{{lesson.id}} -->
                  </td>
                  <td v-if="isXAdmin(userProfile)">
                    <span v-if="lesson.lessonData">{{
                      lesson.lessonData.id
                    }}</span>
                  </td>
                  <td>
                    <div v-if="lesson.lessonData">
                      <span
                        class="text-primary calllink"
                        @click="_goDetail(lesson, school)"
                        >{{ lesson.lessonData.name }}
                        <span
                          v-if="
                            lesson.lessonData.classNos &&
                            lesson.lessonData.classNos.length > 0
                          "
                        >
                          - {{ lesson.lessonData.classNos[0] }}
                          {{ lesson.lessonData.deleted }}
                        </span>
                      </span>

                      <!-- {{lesson.id}} -->
                    </div>
                    <div v-else>
                      <span class="text-danger" style="font-size:9pt"
                        >Энэ группт xичээл xолбогдоогүй байна.</span
                      >
                    </div>
                  </td>
                  <td>{{ lesson.year }} | {{ lesson.month }}</td>
                  <td>
                    <div class="row">
                      <!-- v-if="userProfile && userProfile.role && (userProfile.role=='sts' || userProfile.role=='admin' ) && !lesson.lessonData"  -->
                      <button
                        class="btn btn-danger btn-sm mx-1"
                        @click="deleteGroup(lesson, school)"
                      >
                        устгах
                      </button>
                      <button
                        class="btn btn-warning btn-sm mx-1 mr-4"
                        @click="edit(lesson, school.id)"
                      >
                        засах
                      </button>
                      <i
                        title="сурагч нэмэх"
                        class="fas fa-user-plus icon-bg"
                        @click="_goToStudents(lesson, school)"
                      ></i>
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">
            Та ямар нэгэн бүлэг оруулаагүй байна.
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../../firebaseConfig.js";
import moment from "moment";
import firebase from "firebase";
import myfunction from "../../global/myfunction.js";
// import VueResource from 'vue-resource';
// Vue.use(VueResource);
export default {
  name: "Groups",
  data() {
    return {
      lessonGroups: null,
      semesters: [],
      copyLesson: null,
      copySemester: null,
      schools: [],
      loading: false,
      school: null,
    };
  },
  mixins: [myfunction],
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    this.setupp();
  },
  methods: {
    _goDetail(lesson, school) {
      this.$router.push({
        name: "XILessonDetail",
        params: { schoolId: school.id, lessonId: lesson.lessonData.id },
      });
    },
    saveYearMonth(group) {
      if (group.lessonData != null) {
        if (!group.lessonData.createdAt) {
          return "-";
        }
        let date = group.lessonData.createdAt.toDate();
        var year = moment(date).format("YYYY");
        var month = moment(date).format("MM");
        group.startYear = parseInt(year);
        group.startMonth = parseInt(month);
      }
    },
    async _getLessonGroups(school) {
      var query = fb.db
        .collection("schools")
        .doc(school.id)
        .collection("lessonGroups");
      if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        this.userProfile["customer"] != null &&
        (this.userProfile["role"] == "sts" ||
          this.userProfile["role"] == "admin")
      ) {
        query = query.orderBy("createdAt", "desc");
      } else
        query = query
          .where("teacher", "==", this.userProfile.customer)
          .orderBy("createdAt", "desc");

      query.onSnapshot((querySnapshot) => {
        if (!querySnapshot.empty) {
          this.lessonGroups = [];
          querySnapshot.forEach(async (lessonDoc) => {
            let group = lessonDoc.data();
            group.id = lessonDoc.id;
            group.path = lessonDoc.ref.path;
            group.ref = lessonDoc.ref;
            group.lessonData = null;
         
            if (group.lesson) {
              await group.lesson.get().then((ldoc) => {
                if (ldoc.exists) {
                  group.lessonData = ldoc.data();
                  group.lessonData.id = ldoc.id;
                  group.lessonData.ref = ldoc.ref;
                
                  if (group.startYear == undefined || group.startMonth == undefined) {
                    this.saveYearMonth(group);
                  }
                  if (group.lessonData.deleted) {
                    group.lessonDeleted = true;
                    group.ref.update({ lesson: null });
                  } else {
                    group.lessonDeleted = false;
                  }
                }
              });
            }
            //if(group.lessonData!=null&&group.lessonData.deleted){
            //    if(!group.lessonDeleted)

            this.lessonGroups.push(group);
            //}
          });
        }
      });
      //sorting
    },

    edit(lesson, sId) {
      if (sId && sId != "") {
        if (
          this.userProfile != null &&
          this.userProfile["role"] != null &&
          (this.userProfile["role"] == "admin" ||
            this.userProfile["role"] == "sts")
        ) {
          this.$router.push({
            name: "GroupAdd",
            params: { setTeacher: true, groupId: lesson.id, schoolId: sId },
          });
        } else
          this.$router.push({
            name: "GroupAdd",
            params: { groupId: lesson.id, schoolId: sId },
          });
      }
    },
    _goToStudents(lesson, school) {
      this.$router.push({
        name: "GroupStudent",
        params: { schoolId: school.id, lessonId: lesson.id },
      });
    },
    async setupp() {
      var cusDoc = await this.userProfile["customer"].get();
      if (
        cusDoc.exists &&
        cusDoc.data().school != null &&
        cusDoc.data().school != undefined
      ) {
        var schoolData = await cusDoc.data().school.get();
        let school = schoolData.data();
        school.id = schoolData.id;
        school.ref = schoolData.ref;
        this.school = school;
        await this._getLessonGroups(school);
      }
    },
    _sorting: function () {
      function compare(a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 1;
        return 0;
      }
      return this.lessonCategories.sort(compare);
    },
    async deleteGroup(group, school) {
      var r = confirm("Та энэ группыг устгахдаа итгэлтэй байна уу.");
      if (r == true) {
        await fb.db
          .collection("schools")
          .doc(school.id)
          .collection("lessonGroups")
          .doc(group.id)
          .delete();
        // var submitAnswerFunction = firebase.functions().httpsCallable('cleanGroup');
        // var object={
        //   groupPath: fb.db.collection("schools").doc(school.id).collection("lessonGroups").doc(group.id).path,
        //   schoolId: school.id
        // };
        // var result=await submitAnswerFunction(
        //     object
        // );
        // if(result!=null && result!=undefined && result.data!=null && result.data!=undefined && result.data==true){
        //   await fb.db.collection("schools").doc(school.id).collection("lessonGroups").doc(group.id).delete();
        //   alert(group.name+" амжилттай устгагдлаа.");
        // }
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/YYYY");
    },
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
</style>